




import { defineComponent, onMounted, ref, Ref } from '@vue/composition-api';
import { Engine } from '@babylonjs/core/Engines/engine';
import { Scene } from '@babylonjs/core/scene';
import '@babylonjs/core/Helpers/sceneHelpers';
import { DefaultLoadingScreen } from '@babylonjs/core/Loading/loadingScreen';
import { SceneLoader } from '@babylonjs/core/Loading/sceneLoader';
import { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera';
import { Color4 } from '@babylonjs/core/Maths/math.color';
import { FxaaPostProcess } from '@babylonjs/core/PostProcesses/fxaaPostProcess';
import '@babylonjs/loaders/glTF/2.0/glTFLoader';

export default defineComponent({
  name: 'BabylonViewer',

  props: {
    gltf: {
      type: String,
      default: '',
    },
    controls: {
      type: Boolean,
      default: false,
    },
    antialias: {
      type: Boolean,
      default: false,
    },
    adaptToDeviceRatio: {
      type: Boolean,
      default: false,
    },
    fxaa: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const renderCanvas: Ref<HTMLCanvasElement | null> = ref(null);
    function setupScene() {
      const canvas = renderCanvas.value as HTMLCanvasElement;
      const engine = new Engine(canvas, props.antialias, undefined, props.adaptToDeviceRatio);
      const scene = new Scene(engine);

      DefaultLoadingScreen.prototype.displayLoadingUI = () => undefined;

      const path = props.gltf.substring(0, props.gltf.lastIndexOf('/') + 1);
      const name = props.gltf.substring(props.gltf.lastIndexOf('/') + 1, props.gltf.length);
      SceneLoader.Append(path, name, scene, () => {
        scene.createDefaultCameraOrLight(true);
        const options = {
          createSkybox: false,
          createGround: false,
        };
        scene.createDefaultEnvironment(options);
        scene.clearColor = new Color4(0, 0, 0, 0);
        const camera = scene.activeCamera as ArcRotateCamera;
        if (props.controls) camera.attachControl(canvas, false);
        if (props.fxaa) {
          // eslint-disable-next-line
          const postProcess = new FxaaPostProcess('fxaa', 1.0, camera);
        }
        camera.alpha += Math.PI;

        engine.runRenderLoop(() => {
          if (scene) {
            scene.render();
          }
        });

        window.addEventListener('resize', () => {
          engine.resize();
        });
      });
    }
    onMounted(() => setupScene());

    return {
      renderCanvas,
    };
  },
});
